<template>
  <div class="send-resume-wrapper">
    <transition name="fade">
      <div
        v-if="visible"
        class="background-cover"
        @click="close"
      ></div>
    </transition>
    <transition name="scale">
      <div
        v-if="visible"
        class="box"
      >
        <div class="message-header">
          <span style="font-weight: bold">发送简历至邮箱</span>
          <div class="message-sub-header">输入您的邮箱地址，简历将以PDF格式发送至您的邮箱</div>
        </div>
        <div class="message-content">
          <div class="input-label-title">邮箱账号</div>
          <EditorInput
            v-model="email"
            type="text"
            placeholder="请输入您的邮箱账户"
            border
            styleType="2"
            @input="inputEmail"
          />
          <div
            v-if="showErrMsg"
            class="err-msg"
          >
            <i class="iconfont iconcuowu"></i>
            <span>{{ errorMsg }}</span>
          </div>
        </div>
        <div class="cv-detail">
          <img
            src="https://files.wondercv.com/pdf%402x.png"
            alt=""
            class="cv-detail-img"
          />
          <div class="cv-name">{{ name }}</div>
        </div>
        <div class="message-btn">
          <CompleteButton
            text="取消"
            type="cancel"
            @clickBtn="close"
          />
          <CompleteButton
            text="发送"
            type="confirm"
            :disabled="!email || showErrMsg"
            style="margin-left: 16px"
            @click="clickConfirmSendEmail"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import EditorInput from '../EditorInput/EditorInput.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
export default {
  name: 'ResumeSendEmail',
  components: {
    EditorInput,
    CompleteButton,
  },
  data() {
    return {
      showErrMsg: false,
      errorMsg: '请输入正确的邮箱地址',
      name: '',
      token: '',
      visible: false,
      email: '',
    };
  },
  props: {
    cvToken: {
      type: String,
      default: '',
    },
    cvName: {
      type: String,
      default: '',
    },
    profile: {
      type: Object,
      default: {},
    },
  },
  methods: {
    show() {
      this.name = this.cvName;
      this.token = this.cvToken;
      if (this.profile.email) {
        this.email = this.profile.email;
        this.inputEmail();
      }
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    inputEmail() {
      this.showErrMsg = false;
    },
    clickConfirmSendEmail() {
      const emailExp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      if (!emailExp.test(this.email)) {
        this.showErrMsg = true;
        return;
      }
      this.$emit('confirmSendEmail', this.token, this.email, {
        showProfile: true,
        origin: 'pc',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';

.send-resume-wrapper {
  .background-cover {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 299;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }

  .box {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 301;
    width: 446px;
    height: 341px;
    background-color: $form-bg-color;
    border-radius: 12px;
    .message-header {
      height: fit-content;
      font-size: 18px;
      font-weight: 600;
      color: $modal-label-text-color;
      padding: 28px 32px 26px 32px;
      .message-sub-header {
        font-weight: normal;
        color: #909090;
        font-size: 14px;
        margin-top: 12px;
      }
    }
    .cv-detail {
      height: 26px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      background: $modal-input-bg3-color;
      padding: 0 16px;
      width: calc(100% - 64px);
      height: 51px;
      margin: 10px auto 0;
      img {
        width: 20px;
        margin-right: 8px;
      }
      .cv-name {
        max-width: 266px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: $modal-label-text-color;
      }
    }
    .message-content {
      line-height: 24px;
      padding: 0 32px;
      font-size: 14px;
      color: #606060;
      .input-label-title {
        font-size: 12px;
        margin-bottom: 10px;
        line-height: 12px;
        color: $form-label-color;
      }
      .err-msg {
        display: flex;
        align-items: center;
        color: #ff4f4c;
        margin-top: 10px;
        line-height: 14px;
        i {
          margin-right: 8px;
        }
      }
    }
    .message-btn {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      right: 32px;
      bottom: 32px;
    }
  }
}
</style>
